import { BaseModel } from '@/models/BaseModel';
import { BaseCollection } from './BaseCollection';
import type { MutationsObject } from '@kp/js-model';
import type { Dayjs } from 'dayjs';
import dayjs from 'dayjs';
import { createModel } from '@kp/js-model';

export class KennzahlNutzungsart extends BaseModel {
    // properties
    id: number | null = null;
    created: Dayjs | null = null;
    modified: Dayjs | null = null;
    creator_id: number | null = null;
    modifier_id: number | null = null;

    nutzungsart_id: number | null = null;
    bauperiode_id: number | null = null;
    umrechnungsfaktor_geschossflaeche_ebf: number | null = null;
    umrechnungsfaktor_wohnungsflaeche_ebf: number | null = null;
    stuetzpunkt_unten: number | null = null;
    standadverbauch_stuetzpunkt_unten: number | null = null;
    stuetzpunkt_oben: number | null = null;
    standadverbauch_stuetzpunkt_oben: number | null = null;
    abweichung_standardverbrauch: number | null = null;
    warmwasserbedarf_pro_wohneinheit: number | null = null;
    warmwasserbedarf_pro_m2_ebf: number | null = null;
    begrenzung_energiebezugsflaeche: number | null = null;
    bemerkung: string | null = null;

    // view fields
    nutzungsart: string | null = null;
    nutzungsart_reihenfolge: number | null = null;
    bauperiode_i18n_key: string | null = null;
    bauperiode_code: number | null = null;

    public mutations(): MutationsObject {
        return {
            created: (val) => dayjs(val),
            modified: (val) => dayjs(val),
        };
    }

    getClassName(): string {
        return 'KennzahlNutzungsart';
    }
}

export async function createNewKennzahlNutzungsart(): Promise<KennzahlNutzungsart> {
    const kennzahlnutzungsart = createModel(KennzahlNutzungsart, {});

    await kennzahlnutzungsart.save();
    return kennzahlnutzungsart;
}

export class KennzahlNutzungsartCollection extends BaseCollection<KennzahlNutzungsart> {
    protected modelCls = KennzahlNutzungsart;

    public getModelClassName(): string {
        return 'KennzahlNutzungsart';
    }
}
